import { useEffect, useRef } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMe } from "../hooks/useMe";
import { getStoredAuthTokens, getUser } from "../utils/auth";
import Spinner from "../components/Spinner/Spinner";

export default function RequireCompletedProfile() {
  const { isLoading, me, refetch } = useMe();
  const location = useLocation();
  const retryingRef = useRef(false);
  const storedUser = getUser();
  const { accessToken, refreshToken } = getStoredAuthTokens();
  const hasAuthToken = !!(accessToken || refreshToken);
  const user = me || storedUser;

  // Evita redirecionar indevidamente quando há token mas a primeira busca de /me falhou
  const shouldRetryMe = !isLoading && !me && hasAuthToken;
  useEffect(() => {
    if (shouldRetryMe && !retryingRef.current) {
      retryingRef.current = true;
      refetch();
    }
  }, [shouldRetryMe, refetch]);
  useEffect(() => {
    if (me) retryingRef.current = false;
  }, [me]);

  if (isLoading) return <Spinner />;
  if (!user) {
    if (!hasAuthToken) return <Navigate to="/login" replace />;
    if (!retryingRef.current) return <Spinner />;
    return (
      <Navigate
        to="/login"
        replace
        state={{ msg: "Não foi possível validar sua sessão. Faça login novamente." }}
      />
    );
  }
  const onProfileSetup = location.pathname.startsWith("/musa/profile-setup");
  const rawStep =
    user?.progress_summary?.current_step ??
    user?.progress_summary?.progress_step ??
    user?.progress_step;
  const parsedStep =
    typeof rawStep === "number"
      ? rawStep
      : rawStep && !Number.isNaN(parseInt(rawStep, 10))
      ? parseInt(rawStep, 10)
      : null;
  const documentStatus = (user?.progress_summary?.document_status || user?.document_status || "").toString().toLowerCase();
  const needsResubmission = documentStatus === "needs_resubmission";
  const pendingDocs = documentStatus === "pending_review";
  const documentCompleted =
    (!needsResubmission && (pendingDocs || user.document_verified)) ||
    (parsedStep !== null && parsedStep >= 5 && !needsResubmission);

  if (!user.profile_completed && documentCompleted && !onProfileSetup) {
    return <Navigate to="/musa/profile-setup" replace />;
  }
  return <Outlet />;
}
